import { Col } from 'components/Grid';
import styled, { css, gapSize, screenMobilePlusAndSmaller } from 'theme';
import boxShadow from 'theme/global/box-shadow';

export const QuickLinks = styled.div`
  position: relative;
  background: ${(p) => p.theme.colors.white};
  box-shadow: ${boxShadow.section}};
  padding: ${() => gapSize(1)} 0 ${() => gapSize(4)} 0;

  ${screenMobilePlusAndSmaller(css`
    ${Col} {
      &:last-child {
        margin-top: 0;
      }
    }
  `)};
`;

export const QuickLinkDivider = styled.div`
  background-color: transparent;
  height: 20px;
  width: 100%;
`;
